import { issuperAdminSlice } from "./IsSuperAdmin.redux";

export const { setIsSuperAdmin } = issuperAdminSlice.actions
